import { render, staticRenderFns } from "./PayslipSidebarAddPayment.vue?vue&type=template&id=337a39e4&"
import script from "./PayslipSidebarAddPayment.vue?vue&type=script&lang=js&"
export * from "./PayslipSidebarAddPayment.vue?vue&type=script&lang=js&"
import style0 from "./PayslipSidebarAddPayment.vue?vue&type=style&index=0&id=337a39e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports